import { Tooltip } from 'antd';
import React from 'react';
import DiseaseStatus from '../../../../components/Operation/FishDisease/DiseaseStatus';
import Icon, { ICON_NAME } from '../../../../components/Icon';
import { diseasedZone, diseaseType } from '../../../../util/varibles/constants';
import { IUnit } from '../../../../util/varibles/interface';
import styles from './style.module.scss';

interface FishDiseaseProps {
    diseases?: any[]
    units?: IUnit[]
    wrapperClass?: string
}

const FishDiseaseInline: React.FC<FishDiseaseProps> = ({ diseases = [], units = [], wrapperClass }) => {
    if (!Array.isArray(diseases))
        return null;

    const siteIds = new Set<string>();
    const sites = units.reduce((list: { site_id: string, site_name: string }[], item: any) => {
        const { site_id, site_name } = item;
        if (!siteIds.has(site_id)) {
            siteIds.add(site_id);
            list.push({ site_id, site_name });
        }
        return list;
    }, []);

    diseases.forEach((item) => {
        const { id, name } = item || {};
        if (!id)
            return;

        const [, site_id] = id.split('#');
        if (!siteIds.has(site_id)) {
            siteIds.add(site_id);
            sites.push({ site_id, site_name: name });
        }
    });

    const items = sites.map(({ site_id, site_name }) => {
        const disease = diseases.find(item => (item?.site_id || '').includes(site_id)) || {};
        const unit = units.find(item => item.site_id === site_id);
        const { types = [] } = unit?.unit_diseases || {};
        const { cases = [], diseases: siteDiseases = [] } = disease;
        const { disease: diseaseTypeId = null, status = '' } = cases[0] || {};

        const zoneNames: string[] = [];
        const zoneMarkers = siteDiseases.map((item: any, index: number) => {
            const { shortName = '', color = '' } = diseasedZone[item.type] || {};
            zoneNames.push(shortName);

            if (!color)
                return null;

            return <Tooltip key={`${item.type}-${index}`} title={shortName}>
                <span className={styles.marker} style={{ '--disease-color': color } as React.CSSProperties} />
            </Tooltip>;
        });

        const diseaseNames = [...zoneNames];
        if (diseaseTypeId) {
            const typeName = diseaseType[diseaseTypeId]?.name || '';
            diseaseNames.push(`${typeName} ${status}`.trim());
        }
        diseaseNames.push(...types.map((item: any) => item.name));

        if (diseaseNames.length === 0)
            return null;

        return <div key={site_id} className={styles.line}>
            {zoneMarkers.some(Boolean) && <div className={styles.markers}>{zoneMarkers}</div>}
            {diseaseTypeId && <DiseaseStatus status={diseaseTypeId} />}
            <span className={styles.site}>{site_name}:</span>
            <span>{diseaseNames.join(', ')}</span>
        </div>;
    }).filter(Boolean);

    if (items.length === 0)
        return null;

    const content = <div className={styles.wrapper}>
        <Icon icon={ICON_NAME.DISEASE} size={16} className={styles.icon} />
        <div className={styles.content}>{items}</div>
    </div>;
    return wrapperClass ? <div className={wrapperClass}>{content}</div> : content;
};

export default FishDiseaseInline;
